import React from "react";
import SaitTextField from "./SaitTextField";

export default function SaitNumberField(props) {
	const handleInputChange = (event) => {
		props.onChange(event);
	};

	const handleBlur = (event) => {
		const inputValue = event.target.value;
		if (inputValue.length > 1 && inputValue[0] === "0" && inputValue[1] !== "," && inputValue[1] !== ".") {
			event.target.value = inputValue.replace(/^0+/, "") || "0";
			props.onChange(event);
		}
		props.onBlur?.(event);
	};

	const handleKeyDown = (e) => {
		if (e.key === "ArrowUp" || e.key === "ArrowDown") {
			e.preventDefault(); // Previene l'azione predefinita delle frecce su e giù
		}
	};

	return <SaitTextField {...props} type="number" onChange={handleInputChange} onWheel={(e) => e.target.blur()} onKeyDown={handleKeyDown} />;
}
